import { useMemo } from 'react';

import { generateColorRamp } from 'lib/helpers/brandColors';

const FALLBACK_RAMP = { 50: '#F0F9FF', 100: '#E0F2FE', 200: '#B9E6FE', 300: '#7CD4FD' };

/**
 * Themed version of the Figma "swatch-1c" / "swatch-2c" illustration: a document chip whose
 * tints follow the chosen brand color, plus an accent coin in two-color mode.
 */
const BrandSwatch = ({ primary, accent, isTwoColor = false, size = 72, className }) => {
  const ramp = useMemo(() => generateColorRamp(primary) || FALLBACK_RAMP, [primary]);
  const accentRamp = useMemo(
    () => generateColorRamp(accent || primary) || FALLBACK_RAMP,
    [accent, primary]
  );
  const accentHex = accent || primary;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 72 72"
      fill="none"
      className={className}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M36.0867 65.4231C52.3366 65.4231 65.5097 52.2499 65.5097 36C65.5097 19.7501 52.3366 6.57692 36.0867 6.57692C19.8367 6.57692 6.66357 19.7501 6.66357 36C6.66357 52.2499 19.8367 65.4231 36.0867 65.4231Z"
        fill={ramp[50]}
      />
      <circle cx="5.2788" cy="15.2308" r="1.7308" fill={ramp[200]} />
      <circle cx="64.9905" cy="11.7692" r="1.2981" fill={ramp[200]} />
      <circle cx="67.5866" cy="48.1153" r="2.1635" fill={ramp[100]} />
      <circle cx="3.5481" cy="53.3077" r="1.2981" fill={ramp[100]} />
      <path
        d="M60.6634 18.6923L61.7884 21.4615L64.5576 22.5865L61.7884 23.7115L60.6634 26.4807L59.5384 23.7115L56.7691 22.5865L59.5384 21.4615L60.6634 18.6923Z"
        fill={ramp[300]}
      />
      <rect
        x="16.1828"
        y="15.2307"
        width="39.8077"
        height="45"
        rx="6.0577"
        fill="#252B37"
        opacity="0.06"
      />
      <rect x="16.1829" y="12.6345" width="39.8077" height="45" rx="6.0577" fill="white" />
      <rect
        x="16.1829"
        y="12.6345"
        width="39.8077"
        height="45"
        rx="6.0577"
        stroke={ramp[100]}
        strokeWidth="0.8657"
      />
      <g transform={isTwoColor ? 'translate(-3 0)' : undefined}>
        <circle cx="36.0865" cy="29.9422" r="12.9808" fill={primary} opacity="0.15" />
        <circle cx="36.0864" cy="29.9422" r="9.5192" fill={primary} />
        <path
          d="M33.4903 27.5469C34.939 26.7106 35.7259 25.3614 35.248 24.5336C34.77 23.7058 33.2082 23.7128 31.7595 24.5492C30.3108 25.3856 29.5239 26.7347 30.0018 27.5625C30.4798 28.3903 32.0416 28.3833 33.4903 27.5469Z"
          fill="white"
          opacity="0.45"
        />
      </g>
      <rect x="25.7018" y="45.5192" width="20.7693" height="2.5961" rx="1.298" fill={ramp[200]} />
      <rect
        x="29.1633"
        y="50.7115"
        width="13.8461"
        height="2.1635"
        rx="1.0817"
        fill={isTwoColor ? accentRamp[200] : ramp[100]}
      />
      {isTwoColor && (
        <>
          <circle cx="44.25" cy="36" r="8.25" fill={accentHex} opacity="0.15" />
          <circle cx="44.25" cy="36" r="6" fill={accentHex} />
          <circle cx="44.25" cy="36" r="6.4688" stroke="white" strokeWidth="0.9375" />
        </>
      )}
    </svg>
  );
};

export default BrandSwatch;
